"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryHitLayout = void 0;
const React = __importStar(require("react"));
const assets_1 = require("../assets");
/**
 * Default layout for a Watermark card including an href, thumbnail, and children.
 */
class GalleryHitLayout extends React.Component {
    static defaultProps = {
        className: 'ais-Hits-item',
        aspectRatio: '16by9',
        thumbPosition: 'top',
    };
    /**
     * Sets the URL path to the default thumbnail image.  Can be overridden.
     */
    static DefaultThumbnail = assets_1.WatermarkMediaDefault;
    render() {
        const { href, title, className, thumbnailUrl, thumbPosition, aspectRatio, thumbnailOverlay, children, } = this.props;
        const cols = this.props.columnClasses || ['col-10 col-md-4'];
        const thumb = React.createElement("div", { className: "d-flex flex-column" },
            React.createElement("div", { className: `${className}-thumb embed-responsive embed-responsive-${aspectRatio}` },
                React.createElement("img", { className: `embed-responsive-item card-img-${(thumbPosition != 'bottom') ? 'top' : 'bottom'}`, src: thumbnailUrl || GalleryHitLayout.DefaultThumbnail }),
                thumbnailOverlay));
        return React.createElement("div", { className: `${cols.join(' ')} widget-media-gallery__hit` },
            React.createElement("a", { href: href, className: `${className} a-block d-block card` },
                thumbPosition != 'bottom' && thumb,
                React.createElement("div", { className: "card-body" },
                    title && React.createElement("h2", { className: "card-title" }, title),
                    children),
                thumbPosition == 'bottom' && thumb));
    }
}
exports.GalleryHitLayout = GalleryHitLayout;
